import axiosRestaurantInstance from "../restaurant/AxiosRestaurantInstance";
import { ORGANIZATION_API_PATHS } from "../constants/apiPaths";

export async function fetchPartnerContexts() {
  const response = await axiosRestaurantInstance.get(ORGANIZATION_API_PATHS.partnerContexts);
  return response.data?.contexts || [];
}

export async function switchPartnerContext(contextId) {
  return axiosRestaurantInstance.post(ORGANIZATION_API_PATHS.partnerSwitchContext, {
    contextId,
  });
}
